<input [type]="type" [value]="value" (input)="onInput($event)" (blur)="onTouched()" [disabled]="isDisabled" />
